<template>
    <hts-modal
        v-model="visible"
        title="Ngừng khai thác"
        @close="resetFields">
        <template #custom>
            <p class="font-bold">
                Sau khi "ngừng khai thác", xe sẽ không được đưa vào danh sách điều phối cho tới khi "mở khai thác" trở lại.
            </p>

            <hts-form-radio
                v-model="reason"
                label="Vui lòng chọn lí do ngừng khai thác"
                :items="reasonOptions"
                value-key="key"
                label-key="label"
                required/>

            <hts-form-input
                v-if="reason === 'other'"
                v-model="reasonOrther"
                required
                label="Lý do khác" />

            <div class="flex mt-5 justify-end">
                <hts-form-button
                    color="primary"
                    type="submit"
                    :loading="false"
                    :disabled="CDisabled"
                    @click="submit">
                    Xác nhận
                </hts-form-button>

                <hts-form-button
                    class="pl-2"
                    color="error"
                    @click="close">
                    {{ $t('labels.cancel') }}
                </hts-form-button>
            </div>
        </template>
    </hts-modal>
</template>

<script setup lang="ts">
const emits = defineEmits(['refreshTables'])

const visible = ref(false)
const vehicleId = ref('')
const reason = ref('')
const reasonOrther = ref('')

const reasonOptions = [
  {
    key: 'repair',
    label: 'Sửa chữa'
  },
  {
    key: 'other',
    label: 'Khác'
  }
]

const close = () => {
  resetFields()
  visible.value = false
}

const CDisabled = computed(() => {
  if (!reason.value) { return true }
  if (reason.value === 'other' && !reasonOrther.value) { return true }

  return false
})

const CReasonLabel = computed(() => {
  if (!reason.value) {
    return ''
  }

  if (reason.value === 'other') {
    return reasonOrther.value
  }

  const item = reasonOptions.find((r) => r.key === reason.value)

  if (item) {
    return item.label
  }

  return ''
})

// const {
//   reason,
//   reasonOrther,
//   reasonOptions,
//   CReasonLabel,
//   CDisabled
// } = reasonOption()

const open = (id: string) => {
  vehicleId.value = id
  visible.value = true
}

// const close = () => {
//   resetFields()
//   visible.value = false
// }

const resetFields = () => {
  vehicleId.value = ''
  reason.value = ''
  reasonOrther.value = ''
}

const submit = async () => {
  const api = $url.vehicle.vehicle.stopExploit

  const data: any = await $api(api, {
    uriParams: { ID: vehicleId.value },
    body: {
      reasonStopExploit: reason.value,
      reasonStopExploitLabel: CReasonLabel.value
    }
  })

  const resData = data?.data?.value
  if (resData?.success) {
    emits('refreshTables')
    process.client && $toast().success($t('labels.stopExploitSuccess'))
    close()
  }
}

defineExpose({ open })
</script>
